import api from './auth';

// Configuration for the Spam Analysis API
const SPAM_API_URL = '/spam/check-spam';
const SPAM_REPORT_API_URL = '/spam/report';

/**
 * Récupère le dernier rapport d'analyse anti-spam pour un email donné
 * @param {string} emailId - Identifiant unique de l'email (ex: subject)
 * @returns {Promise<Object>} - Rapport d'analyse structuré ou null
 */
export const getLatestSpamReport = async (emailId) => {
  try {
    const response = await api.get(`${SPAM_REPORT_API_URL}/${encodeURIComponent(emailId)}`);
    if (response.data && response.data.report) {
      // Return the full parsed report object as-is
      return JSON.parse(response.data.report);
    }
    return null;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null; // No report found
    }
    throw error;
  }
};

/**
 * Envoie un email au backend pour analyse anti-spam (nouveau format structuré)
 * @param {Object} emailData - Données de l'email à analyser
 * @param {string} emailData.htmlContent - Contenu HTML de l'email
 * @param {string} emailData.from - Adresse email de l'expéditeur
 * @param {string} emailData.to - Adresse email du destinataire
 * @param {string} emailData.subject - Sujet de l'email
 * @returns {Promise<Object>} - Rapport d'analyse structuré
 */
export const checkSpam = async (emailData) => {
  try {
    const response = await api.post(SPAM_API_URL, {
      htmlContent: emailData.htmlContent,
      from_email: emailData.from,
      to_email: emailData.to,
      subject: emailData.subject
    });
    // Return the full response data as-is
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'analyse anti-spam:", error);
    throw new Error(error.response?.data?.detail || "Échec de l'analyse anti-spam");
  }
};

export default {
  checkSpam,
  getLatestSpamReport
};
 